import { render } from "./RegisteredTradesListing.vue?vue&type=template&id=80a0b14a&scoped=true&ts=true"
import script from "./RegisteredTradesListing.vue?vue&type=script&lang=ts"
export * from "./RegisteredTradesListing.vue?vue&type=script&lang=ts"

import "./RegisteredTradesListing.vue?vue&type=style&index=0&id=80a0b14a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a0b14a"]])

export default __exports__